import React, { useRef, useEffect } from "react";
import "./style.sass";

const TAB_LIST = [
  { id: 1, label: "Account Details" },
  { id: 2, label: "Educational Info" },
  { id: 3, label: "Location" },
];

const AccountDetails = ({ data, onChangeValue, error }) => {
  const { email, name, phone } = data;

  return (
    <section className="tab_content">
      <h4>Email address</h4>
      <input
        name="email"
        value={email}
        onChange={onChangeValue}
        placeholder="name@domain.com"
      />
      {error.errEmail && <p className="err_text">{error.errEmail}</p>}

      <h4>Name</h4>
      <input
        name="name"
        value={name}
        onChange={onChangeValue}
        placeholder="Enter your name"
      />
      {error.errName && <p className="err_text">{error.errName}</p>}
      <h4>Phone Number</h4>
      <input
        name="phone"
        value={phone}
        onChange={onChangeValue}
        placeholder="Enter Your Phone Number"
      />
      {error.errPhone && <p className="err_text">{error.errPhone}</p>}
    </section>
  );
};

const EducationalInfo = ({
  data,
  onChangeValue,
  onFocusChange,
  error,
  eductationLevel,
  gradeClass,
  boards,
  isSchool,
}) => {
  const [focusOpen, setFocusOpen] = React.useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setFocusOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const FOCUS_OPTIONS = [
    "TN_STATE_BOARD", "CBSE", "NEET", "JEE", "UPSC", "BANKING", "TNPSC++",
  ];

  return (
    <section className="tab_content">
      {/* Educational Level */}
      <label>Educational Level</label>
      <select name="level" value={data.level} onChange={onChangeValue}>
        <option value="" disabled>Select level</option>
        {eductationLevel?.map((item, index) => (
          <option key={index} value={item}>{item}</option>
        ))}
      </select>
      {error.errLevel && <p className="err_text">{error.errLevel}</p>}

      {/* Grade & Board — only for school levels */}
      {isSchool && (
        <>
          <label>Class / Grade</label>
          <select name="grade" value={data.grade} onChange={onChangeValue}>
            <option value="" disabled>Select Grade</option>
            {gradeClass?.map((item, i) => (
              <option key={i} value={item}>{item}</option>
            ))}
          </select>
          {error.errGradeClass && <p className="err_text">{error.errGradeClass}</p>}

          <label>Board</label>
          <select name="board" value={data.board} onChange={onChangeValue}>
            <option value="" disabled>Select Board</option>
            {boards?.map((item, i) => (
              <option key={i} value={item}>{item}</option>
            ))}
          </select>
          {error.errBoard && <p className="err_text">{error.errBoard}</p>}
        </>
      )}

      {/* Educational Focus */}
      <label>Educational Focus</label>
      <div className="multiselect_wrapper" ref={wrapperRef}>
        <div
          className="multiselect_trigger"
          onClick={() => setFocusOpen((prev) => !prev)}
        >
          {data.focus.length === 0 ? (
            <span className="multiselect_placeholder">Select Your Educational Board</span>
          ) : (
            <div className="multiselect_tags">
              {data.focus.map((f) => (
                <span key={f} className="multiselect_tag">
                  {f}
                  <button
                    type="button"
                    onClick={(e) => { e.stopPropagation(); onFocusChange(f); }}
                  >
                    &times;
                  </button>
                </span>
              ))}
            </div>
          )}
          <span className="multiselect_arrow">{focusOpen ? "▲" : "▼"}</span>
        </div>
        {focusOpen && (
          <div className="multiselect_dropdown">
            {FOCUS_OPTIONS.map((item, index) => (
              <label key={index} className="multiselect_option">
                <input
                  type="checkbox"
                  checked={data.focus.includes(item)}
                  onChange={() => onFocusChange(item)}
                />
                {item}
              </label>
            ))}
          </div>
        )}
      </div>
      {error.errFocus && <p className="err_text">{error.errFocus}</p>}
    </section>
  );
};

const Location = ({ data, onChangeValue, error }) => {
  return (
    <section className="tab_content">
      <h4>City</h4>
      <input
        name="city"
        value={data.city}
        onChange={onChangeValue}
        placeholder="Enter city"
      />
      {error.errCity && <p className="err_text">{error.errCity}</p>}
    </section>
  );
};

export const SignUp = ({ activeStep, setActiveStep, handler }) => {
  const {
    data,
    error,
    onChangeValue,
    onFocusChange,
    onValidate,
    eductationLevel,
    gradeClass,
    boards,
    isSchool,
  } = handler;

  const renderContent = () => {
    switch (activeStep) {
      case 1:
        return (
          <AccountDetails
            data={data}
            error={error}
            onChangeValue={onChangeValue}
          />
        );
      case 2:
        return (
          <EducationalInfo
            data={data}
            error={error}
            onChangeValue={onChangeValue}
            onFocusChange={onFocusChange}
            eductationLevel={eductationLevel}
            gradeClass={gradeClass}
            boards={boards}
            isSchool={isSchool}
          />
        );
      case 3:
        return (
          <Location
            data={data}
            error={error}
            onChangeValue={onChangeValue}
          />
        );
      default:
        return null;
    }
  };

  return (
    <>
      <section className="tabs_container">
        {TAB_LIST?.map((tab) => (
          <section
            key={tab.id}
            className={`tab_item ${activeStep === tab.id ? "active" : ""}`}
            onClick={() => {
              if (tab.id > activeStep) {
                let allValid = true;
                for (let i = activeStep; i < tab.id; i++) {
                  const { isValid } = onValidate(i);
                  if (!isValid) {
                    allValid = false;
                    setActiveStep(i);
                    break;
                  }
                }
                if (allValid) setActiveStep(tab.id);
              } else {
                setActiveStep(tab.id);
              }
            }}
          >
            <span className="tab_number">{tab.id}</span>
            <span className="tab_label">{tab.label}</span>
          </section>
        ))}
      </section>
      <section className="tab_content_wrapper">{renderContent()}</section>
    </>
  );
};
